import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../assets/logo.gif';
import donate_image from '../assets/center-donate.png';
import { useAuth } from '../utils/authService';
import { db } from '../utils/firebase-config';
import { doc, updateDoc, getDoc, onSnapshot } from "firebase/firestore";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faChalkboardTeacher, faBook, faUser, faSignOutAlt, faChevronDown, faSignIn } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { useLoading } from '../context/LoadingContext';
import Preloader from './Preloader';
import masterclassSteps from '../components/Survey/Questions/Masterclass';


const Layout = ({ children }) => {
  const { isLoading, setIsLoading } = useLoading();
  const location = useLocation();
  const { user } = useAuth();
  const [isFullWidth, setIsFullWidth] = useState(
    JSON.parse(localStorage.getItem('isFullWidth')) || false
  );
  const [hasHeader, setHasHeader] = useState(true);
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(null);
  
  useEffect(() => {
    // Simulate loading state on page transitions
    setIsLoading(true);
    const timeout = setTimeout(() => setIsLoading(false), 500); // Simulated loading time
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  //Coming Soon Page
  const [showComingSoon, setShowComingSoon] = useState(false);

   // Steps that should show the "Coming Soon" page
   const comingSoonSteps = [2, 8, 21];

   useEffect(() => {
    const checkStepForComingSoon = async () => {
      // If no user is logged in, skip the check
      if (!user) return;

      try {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const { currentStep } = userDoc.data();
          // Check if the current step matches any of the "Coming Soon" steps
          if (comingSoonSteps.includes(currentStep)) {
            setShowComingSoon(true);
          } else {
            setShowComingSoon(false);
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    checkStepForComingSoon();
  }, [location.pathname, user]);


    //End Coming Soon Page


  //check if masterclass substep page is and activate fullwidth container
  useEffect(() => {
    const updateLayoutState = async () => {
      // Default values from routeConfig
      let fullWidth = false;
      let header = true;

      // Check for specific routes
      const routeConfig = {
        '/signup': { isFullWidth: true, hasHeader: true },
      };
      const routeSettings = routeConfig[location.pathname] || {};

      // Apply routeConfig first
      if (routeSettings.isFullWidth !== undefined) fullWidth = routeSettings.isFullWidth;
      if (routeSettings.hasHeader !== undefined) header = routeSettings.hasHeader;

      // If on Masterclass page, fetch Firestore data to check masterClassSubStep
      if ((location.pathname.includes('/survey/0') && user) || location.pathname.includes('/survey/0/0' && user)) {
        try {
          const userDocRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const { masterClassSubStep } = userDoc.data();
            const { masterClassStep } = userDoc.data();
            
            if (masterClassSubStep === 0 || masterClassStep === 1) {
              fullWidth = true; // Override for Masterclass Step 0
            } else {
              fullWidth = false;
            }
          }
        } catch (error) {
          console.error('Error fetching Firestore data:', error);
        }
      }
      // if is main decision show full width layout
      else if (location.pathname.includes('/survey/1')) {
        fullWidth = true; 
      }

      // Update state
      setIsFullWidth(fullWidth);
      setHasHeader(header);

      localStorage.setItem('isFullWidth', JSON.stringify(fullWidth));

    };

    updateLayoutState();
  }, [location.pathname, user]);

    // Load the Givebutter widget script
    useEffect(() => {
      const scriptId = "givebutter-widget-script";
      if (!document.getElementById(scriptId)) {
        const script = document.createElement("script");
        script.id = scriptId;
        script.async = true;
        script.src = "https://widgets.givebutter.com/latest.umd.cjs?acct=LLZ8rvanisFi2GD5&p=other";
        document.body.appendChild(script);
      }
    }, []);

    //Ul li to accordion globally
    function toggleAccordionBehavior() {
      const detailsElements = document.querySelectorAll(".accordion-list details");
    
      if (window.innerWidth >= 992) {
        detailsElements.forEach((details) => {
          details.setAttribute("open", ""); // Keep them open on desktop
        });
      } else {
        detailsElements.forEach((details) => {
          details.removeAttribute("open"); // Reset behavior for mobile
        });
      }
    }
    
    // Run on page load
    toggleAccordionBehavior();
    
    // Run on window resize to handle screen changes
    window.addEventListener("resize", toggleAccordionBehavior);
    

  const handleUpdateAndNavigate = async (area, step) => {
    if (user && user.uid) {
      const userDocRef = doc(db, 'users', user.uid);
      try {
        await updateDoc(userDocRef, {
          //[`progress.${area}`]: step,
          currentStep: 0
        });
        navigate(`/${area}/`);
      } catch (error) {
        console.error('Failed to update progress', error);
      }
    }
  };

  if (showComingSoon) {
    return (
      <>
      <Header/>
      <div className="flex items-center justify-center pt-12 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-5xl px-6">
          {/* Left Column */}
          <div className="flex flex-col justify-center ">
          <h1 className="text-4xl font-black text-[#000] uppercase mb-4 text-left">Coming Soon</h1>
          <img src={donate_image} alt="donate" className="" />

            <p className="text-lg text-gray-700 text-left mb-6">
            We’re working to bring this feature to life and create transformative courses for visionary leaders. Your support makes a big impact—donate today and stay tuned for updates!
            </p>
            <givebutter-widget id="pEPy1g"></givebutter-widget>
            {/* <button
              className="mt-6 px-8 py-3 bg-[#fcb900] text-white font-semibold rounded-full hover:bg-amber-600 transition-colors"
              onClick={() => handleUpdateAndNavigate('Profile')}
            >
              Go Back
            </button> */}
            <small className="mt-5">
            Organized by DIFFVELOPMENT<br />
            501(c)(3) Public Charity · EIN 47-4306609<br />
            <a href="mailto:inquiry@diffvelopment.org">inquiry@diffvelopment.org</a>
            </small>
          </div>
  
          {/* Right Column */}
          <div className="flex flex-col items-center justify-center bg-white">
                 {/* Givebutter Widget */}
                 <div id="givebutter-widget-container" className="w-full mt-6">
              <givebutter-widget id="jDR9Wg"></givebutter-widget>
              </div>
      
          </div>
        </div>
      </div>
      </>
    );
  }
  


  return (
    <>
          {isLoading && <Preloader />}
    <div className="min-h-screen bg-white">
           {hasHeader && <Header isFullWidth={isFullWidth} setShowComingSoon={setShowComingSoon}/>}

      <div className={isFullWidth ? 'w-full min-[992px]:pl-24' : 'container mx-auto pb-10 pt-5 min-[992px]:pt-20 min-[992px]:pb-60 mb-10 px-2'}>
        {children}
      </div>
    </div>
    </>
  );
};

const Header = ({ isFullWidth, setShowComingSoon }) => {
  const [completedSubsteps, setCompletedSubsteps] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [coursesDropdownOpen, setCoursesDropdownOpen] = useState(false);
  const [classesDropdownOpen, setClassesDropdownOpen] = useState(false);
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [currentSubStep, setCurrentSubStep] = useState(null);


  useEffect(() => {
    if (!user) return;
  
    const userDocRef = doc(db, "users", user.uid);
  
    const unsubscribe = onSnapshot(userDocRef, (docSnap) => {
      if (docSnap.exists()) {
        const userData = docSnap.data();
        const completedSubsteps = userData.progress?.MasterclassSubsteps || {};
        setCompletedSubsteps(completedSubsteps);
      }
    });
  
    return () => unsubscribe(); // Cleanup on unmount
  }, [user]);
  

  //Fetch user Masterclass progress to output masterclass submenu
  useEffect(() => {
    const fetchUserProgress = async () => {
      if (!user) return;
  
      try {
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
  
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const completedSubsteps = userData.progress?.MasterclassSubsteps || {};
          setCompletedSubsteps(completedSubsteps);
        }
      } catch (error) {
        console.error("Error fetching user progress:", error);
      }
    };
  
    fetchUserProgress();
  }, [user]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/signin');
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  const handleUpdateProgressAndNavigate = async (area, step) => {
    if (user && user.uid) {
      const userDocRef = doc(db, 'users', user.uid);
      try {
        await updateDoc(userDocRef, {
          [`progress.${area}`]: step,
          currentStep: step
        });
        navigate(`/survey/${step}`);
      } catch (error) {
        console.error('Failed to update progress', error);
      }
    }
  };

  const updateMasterClassStep = async (userId, stepId, subStepId = 0) => {
    
    if (!userId) return;
  
    const userDocRef = doc(db, "users", userId);
    try {
      await updateDoc(userDocRef, { 
        masterClassStep: stepId, 
        masterClassSubStep: Number(subStepId) // 🔥 Ensure it's a number
      });
  
      console.log(`✅ Masterclass step updated → Step: ${stepId}, Substep: ${subStepId}`);
    } catch (error) {
      console.error("❌ Error updating masterclass step in Layout.jsx: ", error);
    }
  };
  
  

  const handleSubStepClick = async (subStepId) => {
    if (!user) return;
  
    try {
      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);
  
      if (userDoc.exists()) {
        const userData = userDoc.data();
        const completedSubsteps = userData.progress?.MasterclassSubsteps || {};
        const subStepNum = Number(subStepId);
  
        // 🔥 Update Firestore - Force `currentStep` update
        await updateDoc(userDocRef, {
          [`progress.MasterclassSubsteps.${subStepNum}`]: true,
          currentStep: 0, // ✅ Ensure Firestore correctly sets this
        });
  
        console.log(`✅ Substep ${subStepNum} unlocked. currentStep set to 0.`);
  
        // ✅ Ensure masterclass step is updated
        await updateMasterClassStep(user.uid, 0, subStepNum);
        navigate(`/survey/0/${subStepNum}`);
  
        // ✅ Immediately hide the Coming Soon page
        if (typeof setShowComingSoon === "function") {
          setShowComingSoon(false);
        }
  
        // 🔄 Reload after a short delay to ensure Firestore updates are fetched
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    } catch (error) {
      console.error("❌ Error updating substep progress:", error);
    }
  };
  
  
  

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleCoursesDropdown = () => {
    setCoursesDropdownOpen(!coursesDropdownOpen);
    
  };

  const toggleClassesDropdown = () => {
    setClassesDropdownOpen(!classesDropdownOpen);
  };

  const toggleAccountDropdown = () => {
    setAccountDropdownOpen(!accountDropdownOpen);
  };

  return (
    <header className={isFullWidth ? 'min-[1300px]:absolute inset-x-0 top-0 z-10 bg-transparent' : 'relative max-[992px]:px-4'}>
      <div className={isFullWidth ? 'w-full flex justify-between min-[992px]:flex-row-reverse items-center min-[992px]:pt-0 px-12 pb-5 pt-5' : 'container mx-auto px-4 pb-5 pt-5 flex justify-between min-[992px]:flex-row-reverse items-center min-[992px]:pt-0'}>
        <div className='ml-aut pt-3 min-[992px]:pt-12'>
          <Link to="/survey"> <img src={logo} alt="Logo" className="min-[992px]:max-w-28 max-w-20" /></Link>
        </div>
        <div className="lg:hidden">
          <button onClick={toggleMenu} className="text-black focus:outline-none">
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} className="text-2xl" />
          </button>
        </div>
        <nav className="hidden lg:flex lg:items-center lg:space-x-4 main-nav border-b border-[#fcb900] pb-6 w-full min-[992px]:mr-8">
          <ul className="flex space-x-4">
            {user ? (
              <>
<li className="relative">
  <button 
    onClick={toggleClassesDropdown} 
    className="hover:text-blue-500 text-black flex items-center"
  >
    <FontAwesomeIcon icon={faChalkboardTeacher} className="mr-2" />
    Masterclass <FontAwesomeIcon icon={faChevronDown} className="ml-1" />
  </button>
  
  {classesDropdownOpen && (
    <div className="scrollable-dropdown absolute left-0 mt-2 w-80 bg-white border border-gray-200 rounded shadow-lg">
   {Object.keys(masterclassSteps[0].subSteps).map((subStepId) => {
  const subStep = masterclassSteps[0].subSteps[subStepId];
  const isCurrent = Number(subStepId) === Number(currentSubStep); 
  const isCompleted = completedSubsteps[subStepId]; 
  const isFirstSubStep = subStepId === "0"; 

  // Find the highest unlocked substep to mark as "Continue"
  const latestUnlockedSubstep = Math.max(...Object.keys(completedSubsteps).map(Number), 0);
  const showContinue = Number(subStepId) === latestUnlockedSubstep; // Highlight the next available substep

  if (isCompleted || isFirstSubStep) {
    return (
      <button
        key={subStepId}
        onClick={() => handleSubStepClick(subStepId)}
        className={`block px-4 py-2 text-black hover:bg-gray-200 w-full text-left justify-between 
          ${showContinue ? 'bg-gray-200 font-bold' : ''}`} 
      >
        {subStep.subStepTitle}
        {showContinue && <span className="text-green-500 font-bold"> - Continue</span>} 
      </button>
    );
  }
  return null; 
})}

    </div>
  )}
</li>




                {/* <li>
                  <button 
                    onClick={() => handleUpdateProgressAndNavigate('Masterclass', 0)}
                    className="hover:text-blue-500 text-black flex items-center"
                  >
                    <FontAwesomeIcon icon={faChalkboardTeacher} className="mr-2" />
                    Masterclass
                  </button>
                </li> */}
                <li className="relative">
                  <button 
                    onClick={toggleCoursesDropdown} 
                    className="hover:text-blue-500 text-black flex items-center"
                  >
                    <FontAwesomeIcon icon={faBook} className="mr-2" />
                    Courses <FontAwesomeIcon icon={faChevronDown} className="ml-1" />
                  </button>
                  {coursesDropdownOpen && (
                    <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg">
                      <button 
                        onClick={() => handleUpdateProgressAndNavigate('Finances & Philanthropy', 2)}
                        className="block px-4 py-2 text-black hover:bg-gray-100 w-full text-left"
                      >
                        Finances & Philanthropy
                      </button>
                      <button 
                        onClick={() => handleUpdateProgressAndNavigate('Entrepreneurship & Philanthropy', 8)}
                        className="block px-4 py-2 text-black hover:bg-gray-100 w-full text-left"
                      >
                        Entrepreneurship & Philanthropy
                      </button>
                      <button 
                        onClick={() => handleUpdateProgressAndNavigate('Wealth Building Stage', 21)}
                        className="block px-4 py-2 text-black hover:bg-gray-100 w-full text-left"
                      >
                        Three-Year Financial Plan Assessment
                      </button>
                    </div>
                  )}
                </li>
                <li className="relative">
                  <button 
                    onClick={toggleAccountDropdown} 
                    className="hover:text-blue-500 text-black flex items-center"
                  >
                    <FontAwesomeIcon icon={faUser} className="mr-2" />
                    Account <FontAwesomeIcon icon={faChevronDown} className="ml-1" />
                  </button>
                  {accountDropdownOpen && (
                    <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg">
                      <Link 
                        to="/profile"
                        className="block px-4 py-2 text-black hover:bg-gray-100 w-full text-left"
                        onClick={toggleMenu}
                      >
                        Profile
                      </Link>
                      <button 
                        onClick={() => {
                          handleLogout();
                          toggleMenu();
                        }}
                        className="block px-4 py-2 text-black hover:bg-gray-100 w-full text-left"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/signin" className="hover:text-blue-500 text-[#fcb900] flex items-center">
                    <FontAwesomeIcon icon={faSignIn} className="mr-2" />
                    Sign In
                  </Link>
                </li>
                <li>
                  <Link to="/signup" className="hover:text-blue-500 text-[#fcb900] flex items-center">
                    <FontAwesomeIcon icon={faUser} className="mr-2" />
                    Sign Up
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
      {menuOpen && (
        <div className="lg:hidden fixed top-0 left-0 w-2/3 h-full bg-white shadow-lg z-50 transition-transform transform translate-x-0">
          <div className="flex justify-between items-center p-4">
            <Link to="/survey" onClick={() => setMenuOpen(false)}> 
              <img src={logo} alt="Logo" className="h-20" />
            </Link>
            <button onClick={toggleMenu} className="text-black focus:outline-none">
              <FontAwesomeIcon icon={faTimes} className="text-2xl" />
            </button>
          </div>
          <ul className="flex flex-col space-y-4 px-4">
            {user ? (
              <>
                {/* <li>
                  <button 
                    onClick={() => {
                      handleUpdateProgressAndNavigate('Masterclass', 0);
                      toggleMenu();
                    }}
                    className="hover:text-blue-500 text-black text-left w-full flex items-center"
                  >
                    <FontAwesomeIcon icon={faChalkboardTeacher} className="mr-2" />
                    Masterclass
                  </button>
                </li> */}

                    <li className="relative">
                      <button 
                        onClick={toggleClassesDropdown} 
                        className="hover:text-blue-500 text-black flex items-center"
                      >
                        <FontAwesomeIcon icon={faChalkboardTeacher} className="mr-2" />
                        Masterclass <FontAwesomeIcon icon={faChevronDown} className="ml-1" />
                      </button>
                      
                      {classesDropdownOpen && (
                        <div className="scrollable-dropdown absolute left-0 mt-2 w-64 bg-white border border-gray-200 rounded shadow-lg max-h-80 overflow-y-auto scrollbar-thumb-gray-400 scrollbar-track-gray-200 scrollbar-thin">
                      {Object.keys(masterclassSteps[0].subSteps).map((subStepId) => {
                      const subStep = masterclassSteps[0].subSteps[subStepId];
                      const isCurrent = Number(subStepId) === Number(currentSubStep); 
                      const isCompleted = completedSubsteps[subStepId]; 
                      const isFirstSubStep = subStepId === "0"; 

                      // Find the highest unlocked substep to mark as "Continue"
                      const latestUnlockedSubstep = Math.max(...Object.keys(completedSubsteps).map(Number), 0);
                      const showContinue = Number(subStepId) === latestUnlockedSubstep; // Highlight the next available substep

                      if (isCompleted || isFirstSubStep) {
                        return (
                          <button
                            key={subStepId}
                            onClick={() => handleSubStepClick(subStepId)}
                            className={`block px-4 py-2 text-black hover:bg-gray-100 w-full text-left text-sm justify-between 
                              ${showContinue ? 'bg-gray-200 font-bold' : ''}`} 
                          >
                            {subStep.subStepTitle}
                            {showContinue && <span className="text-green-500 font-bold"> - Continue</span>} 
                          </button>
                        );
                      }
                      return null; 
                    })}

                        </div>
                      )}
                    </li>

                <li>
                  <button 
                    onClick={() => {
                      handleUpdateProgressAndNavigate('Finances & Philanthropy', 2);
                      toggleMenu();
                    }}
                    className="hover:text-blue-500 text-black text-left w-full flex items-center"
                  >
                    <FontAwesomeIcon icon={faBook} className="mr-2" />
                    Finances & Philanthropy
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => {
                      handleUpdateProgressAndNavigate('Entrepreneurship & Philanthropy', 8);
                      toggleMenu();
                    }}
                    className="hover:text-blue-500 text-black text-left w-full flex items-center"
                  >
                    <FontAwesomeIcon icon={faBook} className="mr-2" />
                    Entrepreneurship & Philanthropy
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => {
                      handleUpdateProgressAndNavigate('Wealth Building Stage',21);
                      toggleMenu();
                    }}
                    className="hover:text-blue-500 text-black text-left w-full flex items-center"
                  >
                    <FontAwesomeIcon icon={faBook} className="mr-2" />
                    Three-Year Financial Plan Assessment
                  </button>
                </li>
                <li>
                  <Link to="/profile" className="hover:text-blue-500 text-black flex items-center" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={faUser} className="mr-2" />
                    Profile
                  </Link>
                </li>
                <li>
                  <button onClick={() => {
                    handleLogout();
                    toggleMenu();
                  }} 
                  className="hover:text-red-500 text-black text-left w-full flex items-center">
                    <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
              <div className='pt-8 pb-8 text-center'><p><strong>Welcome to the DIFF Center </strong></p>
              </div>
              <div className="flex max-[995px]:flex-col justify-around">
                <li>
                  <Link to="/signin" className="px-6 py-3 mt-4 orange-bg font-semibold rounded-full hover:orange-bg transition-colors" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={faSignIn} className="mr-2" />
                    Sign In
                  </Link>
                </li>
                <li className="max-[995px]:mt-8">
                  <Link to="/signup" className="px-6 py-3 mt-4 max-[995px]:mt-8 bg-transparent border[#FCB900] orange-text border-solid border font-semibold rounded-full hover:orange-bg transition-colors" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={faUser} className="mr-2" />
                    Sign Up
                  </Link>
                </li>
                </div>
              </>
            )}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Layout;
